// Module
var code = "<p>Enabling instant survey notifications, our system notifies you by email as soon as someone finishes your questionnaire.</p> <p>The email will be sent to the email you used upon registration.</p> ";
// Exports
module.exports = code;